module.exports = __webpack_public_path__ + "static/media/ic_seats_booked.0aea0c5f.png";